const BasicDetails = () => {
    return (
        <div className="vision-card">
            <div id="basic">

                <h3 className="table-section-heading">
                    BASIC DETAILS
                </h3>

                <div className="table-section-wrap">
                    <table className="table-section basic-table">

                        <thead>

                        </thead>

                        <tbody>

                            <tr>
                                <td>SCHOOL NAME</td>
                                <td>NAV JEEVAN MISSION INTERNATIONAL SCHOOL</td>
                                <td>SCHOOL CODE</td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>ADDRESS</td>
                                <td>NAV JEEVAN MISSION SCHOOL,SONAULI ROAD,ANANDNAGAR</td>
                                <td>AFFILIATION CODE</td>
                                <td>0</td>
                            </tr>

                            <tr>
                                <td>PRINCIPAL</td>
                                <td>MR BINU K R</td>
                                <td>PRINCIPAL'S CONTACT NUMBER</td>
                                <td>7081803503</td>
                            </tr>

                            <tr>
                                <td>PRINCIPAL'S EMAIL ID</td>
                                <td>binukr.ravindran@gmail.com</td>
                                <td>PRINCIPAL'S RETIREMENT DATE</td>
                                <td>0</td>
                            </tr>

                            <tr>
                                <td>SCHOOL'S CONTACT NUMBER</td>
                                <td>91-7081803502,501</td>
                                <td>SCHOOL'S EMAIL ID</td>
                                <td>navjeevaninternational3@gmail.com</td>
                            </tr>

                            <tr>
                                <td>SCHOOL'S WEBSITE</td>
                                <td>www.navjeevaninternationalschool</td>
                                <td>SCHOOL'S FAX NUMBER</td>
                                <td>0000000000</td>
                            </tr>

                            <tr>
                                <td>LANDMARK NEAR SCHOOL</td>
                                <td>GULHARIYA THANA</td>
                                <td>YEAR OF ESTABLISHMENT</td>
                                <td>2018</td>
                            </tr>

                            <tr>
                                <td>AFFILIATION VALIDITY</td>
                                <td>0</td>
                                <td>AFFILIATION STATUS</td>
                                <td>0</td>
                            </tr>

                            <tr>
                                <td>NAME OF THE TRUST / SOCIETY / COMPANY REGISTERED</td>
                                <td>NAVJEEVAN MISSION NATIONAL EDUCATIONAL SOCIETY</td>
                                <td>REGISTRATION DATE</td>
                                <td>25/11/2010</td>
                            </tr>

                            <tr>
                                <td>SOCIETY REGISTRATION NUMBER</td>
                                <td>1187/2010-2011</td>
                                <td>REGISTRATION VALIDITY</td>
                                <td>25/11/2020</td>
                            </tr>

                            <tr>
                                <td>NOC ISSUING AUTHORITY</td>
                                <td>(Govt.Of UTTARPRADESH)J.D. OFFICE</td>
                                <td>NOC ISSUING DATE</td>
                                <td>27/06/2014</td>
                            </tr>

                            <tr>
                                <td>NO OBJECTION CERTIFICATE</td>
                                <td>0</td>
                                <td>NON PROPRIETY CHARACTER AFFIDAVIT /NON PROFIT COMPANY AFFIDAVIT</td>
                                <td>0</td>
                            </tr>

                        </tbody>

                    </table>
                </div>

            </div>
        </div>

    );
};

export default BasicDetails;